export default {
  dbu_report_title: '报告标题',
  dbu_report_preview_summary_card_title: '报告列表',
  dbu_report_preview_content_card_title: '报告内容',
  dbu_report_share_new_report: '报告分享',
  dbu_report_share_market_report: '市场报告分享',
  dbu_report_preview_back_btn_text: '返回编辑',
  dbu_report_search_placeholder: '根据标题搜索',
  dbu_report_publish_success_tips: '分享成功',
  dbu_report_publish_success_tips_desc: '感谢您对DataBrain的贡献！',
  dbu_report_publish_success_btn1_text: '查看我的报告',
  dbu_report_publish_success_btn2_text: '返回报告列表',
  dbu_report_delete_confirm_title: '你确定要删除这个报告吗？',
  dbu_report_delete_confirm_desc: '删除后将无法恢复。',
  dbu_report_uploader_title: '报告分享',
  dbu_report_file_cn: '文件-中文',
  dbu_report_file_en: '文件-英文',
  dbu_report_file: '报告',
  dbu_report_file_language: '报告语言',
  dbu_report_title_cn: '标题-中文',
  dbu_report_title_placeholder_cn: '请输入中文标题',
  dbu_report_title_en: '标题-英文',
  dbu_report_title_placeholder_en: '请输入英文标题',
  dbu_report_abstract_cn: '摘要-中文',
  dbu_report_abstract_placeholder_cn: '请输入中文摘要',
  dbu_report_abstract_en: '摘要-英文',
  dbu_report_abstract_placeholder_en: '请输入英文摘要',
  dbu_report_tag_cn: '标签-中文',
  dbu_report_tag_en: '标签-英文',
  dbu_report_tag_placeholder: '标签将以，或；或 | 分隔',
  dbu_report_cover: '封面',
  dbu_report_location: '报告位置',
  dbu_report_location_level1: '一级分类',
  dbu_report_location_level2: '二级分类',
  dbu_report_location_level3: '三级分类',
  dbu_report_location_placeholder: '请选择报告分类',
  dbu_report_permission: '权限',
  dbu_report_permission_placeholder: '请选择开放权限',
  dbu_report_permission_all: '全部',
  dbu_report_author: '作者id',
  dbu_report_author_number: '作者 {number}',
  dbu_report_author_placeholder: '请输入作者id',
  dbu_report_author_org_structure: '组织架构',
  dbu_report_author_org_structure_placeholder: '请输入组织架构',
  dbu_report_add_author: '添加作者',
  dbu_report_delete_author: '删除',
  dbu_report_clear_avatar: '清空头像',
  dbu_report_update_image: '更新图片',
  dbu_report_author_required_tips: '请在确认前填写完整必填项',
  dbu_report_author_duplicate_tips: '作者id重复，请重新输入',
  dbu_report_download_enable: '是否允许下载',
  dbu_report_watermark_enable: '是否有水印',
  dbu_report_form_tips: 'Brainy已生成初步报告详情，请审核并根据需要进行完善。',
  dbu_report_upload_en_version_report: '上传英文版本以获得更多曝光',
  dbu_report_upload_cn_version_report: '上传中文版本以获得更多曝光',
  dbu_report_add_update_error_tips1: '只能发本人的报告',
};
